<template>
<div class="container" id="page">
<h1 class="text-center">Acceptable Use Policy</h1>

<p>About us</p>

<p>This acceptable use policy sets out the terms between you and us under which you may access our website <a href="https://giraffecompetitions.co.uk/" >https://www.competitionmania.co.uk</a> (“our site”). This acceptable use policy applies to all users of, and visitors to, our site.</p>

<p>Your use of our site means that you accept, and agree to abide by, all the policies in this acceptable use policy, which supplement our terms of website use.</p>

<p>Our site is a site operated by Competition Mania (“We”). We are located at Competition Mania, Made Simple Group 20-22 Wenlock Road, London, N1 7GU. To contact us, please email <a href="mailto:info@competitionmania.co.uk" >info@competitionmania.co.uk</a> </p>

<p>Prohibited uses</p>

<p>You may use our site only for lawful purposes. You may not use our site:</p>

<ul>
<li><p>In any way that breaches any applicable local, national or international law or regulation.</p>

</li>
<li><p>In any way that is unlawful or fraudulent, or has any unlawful or fraudulent purpose or effect.</p>

</li>
<li><p>For the purpose of harming or attempting to harm minors in any way.</p>

</li>
<li><p>To send, knowingly receive, upload, download, use or re-use any material which does not comply with our content standards as set out below. </p>

</li>
<li><p>To transmit, or procure the sending of, any unsolicited or unauthorised advertising or promotional material or any other form of similar solicitation (spam).</p>

</li>
<li><p>To knowingly transmit any data, send or upload any material that contains viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware, adware or any other harmful programs or similar computer code designed to adversely affect the operation of any computer software or hardware.</p>

</li>
</ul>

<p>You also agree:</p>

<ul>
<li><p>Not to reproduce, duplicate, copy or re-sell any part of our site in contravention of the provisions of our terms of website use.</p>

</li>
<li><p>Not to access without authority, interfere with, damage or disrupt:</p>

</li>
<li><p>any part of our site;</p>

</li>
<li><p>any equipment or network on which our site is stored; </p>

</li>
<li><p>any software used in the provision of our site; or </p>

</li>
<li><p>any equipment or network or software owned or used by any third party.</p>

</li>
</ul>

<p>Interactive services</p>

<p>We may from time to time provide interactive services on our site, for example, the ability to participate in games, competitions, comment on blog posts or post to our social media accounts (interactive services).</p>

<p>Where we do provide any interactive service, we will provide clear information to you about the kind of service offered, if it is moderated and what form of moderation is used (including whether it is human or technical).</p>

<p>We will do our best to assess any possible risks for users (and in particular, for children) from third parties when they use any interactive service provided on our site, and we will decide in each case whether it is appropriate to use moderation of the relevant service (including what kind of moderation to use) in the light of those risks. However, we are under no obligation to oversee, monitor or moderate any interactive service we provide on our site, and we expressly exclude our liability for any loss or damage arising from the use of any interactive service by a user in contravention of our content standards, whether the service is moderated or not. </p>

<p>The use of any of our interactive services by a minor is subject to the consent of their parent or guardian. We advise parents who permit their children to use an interactive service that it is important that they communicate with their children about their safety online, as moderation is not foolproof. Minors who are using any interactive service should be made aware of the potential risks to them. </p>

<p>Where we do moderate an interactive service, we will normally provide you with a means of contacting the moderator, should a concern or difficulty arise.</p>

<p>Content standards</p>

<p>These content standards apply to any and all material which you contribute to our site (contributions), and to any interactive services associated with it. </p>

<p>You must comply with the spirit and the letter of the following standards. The standards apply to each part of any contribution as well as to its whole.</p>

<p>Contributions must:</p>

<ul>
<li><p>Be accurate (where they state facts).</p>

</li>
<li><p>Be genuinely held (where they state opinions).</p>

</li>
<li><p>Comply with applicable law in the UK and in any country from which they are posted.</p>

</li>
</ul>

<p>Contributions must not:</p>

<ul>
<li><p>Contain any material which is defamatory of any person.</p>

</li>
<li><p>Contain any material which is obscene, offensive, hateful or inflammatory.</p>

</li>
<li><p>Promote sexually explicit material.</p>

</li>
<li><p>Promote violence.</p>

</li>
<li><p>Promote discrimination based on race, sex, religion, nationality, disability, sexual orientation or age.</p>

</li>
<li><p>Infringe any copyright, database right or trademark of any other person.</p>

</li>
<li><p>Be likely to deceive any person.</p>

</li>
<li><p>Be made in breach of any legal duty owed to a third party, such as a contractual duty or a duty of confidence.</p>

</li>
<li><p>Promote any illegal activity.</p>

</li>
<li><p>Be threatening, abuse or invade another’s privacy, or cause annoyance, inconvenience or needless anxiety.</p>

</li>
<li><p>Be likely to harass, upset, embarrass, alarm or annoy any other person.</p>

</li>
<li><p>Be used to impersonate any person, or to misrepresent your identity or affiliation with any person.</p>

</li>
<li><p>Give the impression that they emanate from us, if this is not the case.</p>

</li>
<li><p>Advocate, promote or assist any unlawful act such as (by way of example only) copyright infringement or computer misuse.</p>

</li>
</ul>

<p>Suspension and termination</p>

<p>We will determine, in our discretion, whether there has been a breach of this acceptable use policy through your use of our site. When a breach of this policy has occurred, we may take such action as we deem appropriate. </p>

<p>Failure to comply with this acceptable use policy constitutes a material breach of the terms of use upon which you are permitted to use our site, and may result in our taking all or any of the following actions:</p>

<ul>
<li><p>Immediate, temporary or permanent withdrawal of your right to use our site.</p>

</li>
<li><p>Immediate, temporary or permanent removal of any posting or material uploaded by you to our site.</p>

</li>
<li><p>Issue of a warning to you.</p>

</li>
<li><p>Legal proceedings against you for reimbursement of all costs on an indemnity basis (including, but not limited to, reasonable administrative and legal costs) resulting from the breach.</p>

</li>
<li><p>Further legal action against you.</p>

</li>
<li><p>Disclosure of such information to law enforcement authorities as we reasonably feel is necessary.</p>

</li>
</ul>

<p>We exclude liability for actions taken in response to breaches of this acceptable use policy. The responses described in this policy are not limited, and we may take any other action we reasonably deem appropriate.</p>

<p>Changes to the acceptable use policy</p>

<p>We may revise this acceptable use policy at any time by amending this page. You are expected to check this page from time to time to take notice of any changes we make, as they are legally binding on you. Some of the provisions contained in this acceptable use policy may also be superseded by provisions or notices published elsewhere on our site.</p>

<p>Free Postal Draw</p>

<p>To enter for free send a first class postcard stating your: Full Name, Full Address, Email Address, Phone Number, Competition and Competition Code, Answer To Competition Question, Agreement to Terms and Conditions. All entries must be sent to Competition Mania, Made Simple Group, London, N1 7GU and received 2 working days before the close of the competition.</p>

<p>Please ensure you have read and agree to our terms and conditions before entering by post or online. If your entries do not comply with the terms they will not be included in the draw. Please note, you must sign up for an account before making your entry! Entries submitted without an associated account cannot be processed. You must add your billing address to your account in order for your entries to be processed. </p>

<br>


  </div>
  <Footer/>
</template>



<script>
import Footer from '../components/global/Footer'

export default {
    components: {
        Footer
    }
}
</script>